import gql from 'graphql-tag';

export default gql`
  mutation UploadImage($image: Upload!, $scope: PhotoUploadScopeEnumType!) {
    dailyTracker {
      uploadImage(image: $image, scope: $scope) {
        __typename
        ... on UploadImageSuccess {
          imageUrl
        }
        ... on Error {
          errorCode: code
          name
          description
        }
        ... on UnauthorizedException {
          code
        }
        ... on ValidationException {
          code
          messages
        }
      }
    }
  }
`;
